module.exports = __webpack_public_path__ + "img/img2.d37a4132.jpg";